module.exports = __webpack_public_path__ + "static/media/17.65ee5a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/17.png
// module id = 1390
// module chunks = 0